import type { CommunicatorPackedMessage, File } from 'reactApp/modules/integration/integration.types';

// todo: использовать модуль Communicator из @vkontakte/cloud-integration-sdk, когда он будет опубликован
function sendMessage(targetOrigin: string, name: string, payload?: Record<string, any>) {
    const packedMessage: CommunicatorPackedMessage = {
        name,
        __cloudMessage: true,
    };
    if (payload) {
        packedMessage.payload = JSON.stringify(payload);
    }

    if (window.opener && targetOrigin) {
        window.opener.postMessage(packedMessage, targetOrigin);
    } else if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('%c [integration]', 'font-weight: bold', 'sending message', packedMessage, 'to origin ', targetOrigin);
    }
}

export function sendSuccess(parentOrigin: string, files: File[]) {
    sendMessage(parentOrigin, 'cloud:publish_success', { files });
}

export function sendClose(parentOrigin: string) {
    sendMessage(parentOrigin, 'cloud:close');
}
